import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const checkoutUpdateOrderActions = createDataModuleActions(
    'CHECKOUT_UPDATE_ORDER',
);

export const checkoutUpdateOrder = checkoutUpdateOrderActions.dataRequest;
export const checkoutUpdateOrderSuccess =
    checkoutUpdateOrderActions.dataSuccess;
export const checkoutUpdateOrderError = checkoutUpdateOrderActions.dataError;
export const checkoutUpdateOrderReset = checkoutUpdateOrderActions.dataReset;
